//import 'babel-polyfill';
import 'core-js/es7/object';
import 'core-js/es6/math';
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import VueGtag from "vue-gtag";
import * as VueGoogleMaps from 'vue2-google-maps'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import 'vuetify/dist/vuetify.min.css'
import VueResource from 'vue-resource'
import router from './router'
import './pixel.js'
import './gtm.js'

import currency from 'v-currency-field'
import 'v-currency-field/dist/index.css'

import $ from "jquery";

Vue.use(currency);

//Vue.use(VueRouter)
Vue.use(VueResource);
Vue.prototype.$apiBaseUrl = "https://www.first5sc.org";

Vue.use(Vuetify, {
  theme: {
    primary: '#1b3675',
    red: '#ef0909',
    orange: '#f7930a',
    green: '#66da39',
    purple: '#950af7',
    background: 'white',
    darkblue: "#0c1430",
    lightblue: "#468cca"
  }
});

//ATTENTION!!!
//google maps script and key is loaded through index.html not below
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAb0HhhJgHgraMCiZt-rCPjlaIQjjrGfm8',
      libraries: 'places,geometry', // This is required if you use the Autocomplete plugin
      // OR: libraries: 'places,drawing'
      // OR: libraries: 'places,drawing,visualization'
      // (as you require)
      
      //// If you want to set the version, you can do so:
      // v: '3.26',
    },
    
    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,
    
    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
  });






Vue.use(VuetifyGoogleAutocomplete, {
    apiKey: 'AIzaSyAb0HhhJgHgraMCiZt-rCPjlaIQjjrGfm8',  
    
    });
Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "UA-150738227-1" },
  includes: [{  id: 'AW-670219579'}]
}, router);


new Vue({
 
  router,
  render: h => h(App)
}).$mount('#app')


$(document).ready(function(){
  $('.menu-toggle').click(function(){
    $('.menu').addClass('active')
  });

  $('.menu-close').click(function(){
    $('.menu').removeClass('active');
  });
});



